const Notification = {
  defaultProps: {
    radius: 'sm',
    withBorder: true,
    withCloseButton: true,
  },
  styles: {
    icon: {
      marginInlineStart: 'var(--mantine-spacing-xs)',
      marginInlineEnd: 'var(--mantine-spacing-sm)',
    },
  },
}

export default Notification
